'use strict'

const Helpers = require('../../_plugins/lib/helpers')
const { object } = require('prop-types')

const splitTestHelper = {
  contextTypes: {
    store: object
  },

  getInitialState () {
    const { context = {} } = this
    return {
      splitTestData: context.store ? context.store.getState().splitTestData : { }
    }
  },

  componentDidMount () {
    this.subscribeToSplitTestStore()
  },

  subscribeToSplitTestStore () {
    if (!this.context.store) return
    this.context.store.subscribe(() => {
      this.setState({
        splitTestData: this.context.store.getState().splitTestData
      })
    })
  },

  // Takes a string of the split test name and verifies if its turn on or off (can be the snake case version or the camel case version)
  splitTestIsActive (splitTest) {
    const { splitTestData } = this.state
    if (!splitTest) return false
    if (splitTest.match(/_/)) splitTest = this.snakeToCamel(splitTest)
    if (splitTestData[splitTest] && splitTestData[splitTest].hasOwnProperty('active')) return splitTestData[splitTest].active
    return false
  },

  // Takes a string of the split test name (can be the snake case version or the camel case version), also takes the object you wish to inject into the state for the defined split test
  injectSplitTestData (splitTest, newSplitTestData) {
    if (!splitTest || typeof newSplitTestData !== 'object') return false // Value could be set to false, so check if its not defined this way instead.
    if (splitTest.match(/_/)) splitTest = this.snakeToCamel(splitTest)
    if (!this.context.store) return true
    this.context.store.dispatch({
      type: 'INJECT_TEST_DATA',
      data: { name: splitTest, newSplitTestData }
    })
  },

  snakeToCamel (string) {
    return string.replace(/(_\w)/g, (match) => match[1].toUpperCase())
  },

  detectIE () {
    var versionArr = navigator.userAgent.match(/MSIE (\d+\.\d+);/)
    if (versionArr instanceof Array && versionArr.length > 1) return versionArr[1] / 1
    return false
  },

  // Pass a 'pattern' in as a regular expression to only active this split test on certain pages, disclude it and will always run
  initialiseSplitTest (splitTestData) {
    if (!splitTestData || !splitTestData.name || !splitTestData.percentage) return false
    const { pageData: { pageName } } = this.props
    if (splitTestData.pattern && !pageName.match(splitTestData.pattern)) return false
    let stopTheSplitTest = false
    if (splitTestData.discludeIE) {
      splitTestData.discludeIE.map((version) => {
        if (this.detectIE() === version) stopTheSplitTest = true
      })
    }
    if (stopTheSplitTest) return false
    const status = Helpers.isSplitTest(splitTestData.name, splitTestData.percentage)
    if (!this.context.store) return true
    this.context.store.dispatch({
      type: 'INITIALISE_TEST',
      data: { name: this.snakeToCamel(splitTestData.name), status }
    })
  }

}

module.exports = splitTestHelper



// WEBPACK FOOTER //
// ./shared/states/splitTestData.jsx